<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__content">
        <form
          class="content"
          [formGroup]="giftFormGroup"
          (submit)="onSubmit()"
        >
          <div class="content__input">
            <lib-input
              label="ギフトコード"
              formControlName="code"
              [error]="(codeError$ | async) || REQUIRED_ERROR"
            ></lib-input>
          </div>
          <div class="content__button">
            <lib-button
              [disabled]="(loading$ | async) || giftFormGroup.invalid"
              [fullWidth]="true"
              >OK</lib-button
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
